import React from 'react';
import './personalCard.css';
import cardImage from '../../assets/cardImage.jpg';
import { Link } from 'react-router-dom';

const PersonalCard = ({ language }) => {
  return (
    <div className="card-container">
      <section className="card-visual">
        <div className="card-img-container">
          <img className="card-img" src={cardImage} alt="PersonalImage" />
        </div>
      </section>

      <section className="card-info">
        <h1>Maximiliano Melani Ghirardi</h1>
        {language === 'English' ? (
          <>
            <h2>Front End Web Developer</h2>
            <p>
              Full Stack Web Developer (Front End especialized on React) and
              Technician in Administration and Tax Management.
              <br />I make highly customizable and scalable user interfaces in
              React. I'm passionate about creating innovative and efficient
              solutions for my clients.
              <br />
              If you are looking for a Front End Developer for your next
              project, I'm sure I can help you to achieve your goals and provide
              an unique user experience.
              <br />
              You can
              <Link to="/contact" className="contact-link">
                {' '}
                contact me
              </Link>
              , I will answer as soon as possible.
            </p>
          </>
        ) : (
          <>
            <h2>Desarrollador Web Front End</h2>
            <p>
              Desarrollador Web Full Stack (Front End especialización en React)
              y Técnico en Administración y Gestión Tributaria.
              <br />
              Creo interfaces de usuario altamente personalizadas y escalables
              en React. Apasionado por crear soluciones innovadoras y eficientes
              para mis clientes.
              <br />
              Si estás buscando un Desarrollador Web Front End para tu próximo
              proyecto, estoy seguro de que puedo ayudarte a lograr tus
              objetivos y brindarte una experiencia de usuario única.
              <br />
              Si lo deseas podés
              <Link to="/contact" className="contact-link">
                {' '}
                contactarme
              </Link>
              , te responderé lo antes posible.
            </p>
          </>
        )}
      </section>
    </div>
  );
};

export default PersonalCard;
